import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
// 3rd Party
// Modules
import { DatatableModule } from './datatable/datatable.module';
import { NRModalModule } from './modal/modal.module';
import { FormModule } from './form-field/form.module';

@NgModule({
    declarations: [
    ],
    imports: [
        CommonModule,
        FormsModule,
        DatatableModule,
        FormModule,
        NRModalModule
    ],
    exports: [
        DatatableModule,
        FormModule,
        NRModalModule
    ]
})
export class SharedModule { }
